import { apiClient } from './api-client';
import { UserSchema, type User } from '../schemas/user.schema';

export const meService = {
    get: (): Promise<User> => apiClient.get('me', UserSchema),
    rename: (handle: string): Promise<User> => apiClient.patch('me', { handle }, UserSchema),
};
